import { getPageData } from '@/utils/getPageData';
import { QueryKey } from '@tanstack/react-query';
import { useGetProjectCodesSuspenseInfinite } from 'ap-openapi';
import { useEffect, useMemo } from 'react';

export const useGetProjectCodesAllSuspense = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetProjectCodesSuspenseInfinite(
      {
        per: 1000,
      },
      {
        query: {
          getNextPageParam: (page) => {
            const url = new URL(page.data.next ?? '/', location.href);
            if (!url.searchParams.has('page')) return undefined;
            return Number(url.searchParams.get('page'));
          },
        },
      }
    );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  return useMemo(() => getPageData(data, 'project_codes'), [data]);
};

type UseGetProjectCodesWithAgentApplicantResourceOptions = {
  queryKey?: QueryKey;
};

export const useGetProjectCodesWithAgentApplicantResource = (
  options?: UseGetProjectCodesWithAgentApplicantResourceOptions
) => {
  const { queryKey } = options || {};
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
  } = useGetProjectCodesSuspenseInfinite(
    {
      per: 1000,
    },
    {
      query: {
        getNextPageParam: (page) => {
          const url = new URL(page.data.next ?? '/', location.href);
          if (!url.searchParams.has('page')) return undefined;
          return Number(url.searchParams.get('page'));
        },
        queryKey,
      },
      request: {
        headers: {
          agentApplicantResource: 'project',
        },
      },
    }
  );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  const items = useMemo(() => getPageData(data, 'project_codes'), [data]);

  return {
    items,
    isLoading: isFetching || isFetchingNextPage || hasNextPage,
  };
};
